<script>
import UtilsMixin from "@/mixins/utils";
import LocaleMixin from "@/mixins/locale";

export default {
  name: 'PrintHistoryDebtCustomer',
  components: {},
  props: {
    distributor: Object,
    data: Object,
    me: Object,
  },
  data() {
    return {
      timePrint: {
        year: new Date().getFullYear(),
        month:
            new Date().getMonth() >= 10
                ? new Date().getMonth() + 1
                : `0${new Date().getMonth() + 1}`,
        day:
            new Date().getDate() >= 10
                ? new Date().getDate()
                : `0${new Date().getDate()}`,
        hour: new Date().getHours(),
        min: new Date().getMinutes(),
        sec: new Date().getSeconds(),
      },
      fields: [
        {header: 'time', key: 'document_time'},
        {header: 'document_code', key: 'document_id'},
        {header: 'explain', key: 'document_type_text'},
        {header: 'value', key: 'document_amount'},
        {header: 'debt', key: 'debt_amount'}
      ]
    };
  },
  mixins: [UtilsMixin, LocaleMixin],
  methods: {
    translateCol(value){
      switch (value) {
        case 'opening_balance':
        case 'ending_balance':
          return this.$t(value);
        case 'ORDER':
          return this.$t('order')
        case 'PAYMENT':
          return this.$t('bill');
        default:
          return value;
      }
    }
  }
};
</script>

<template>
  <div class="page-landscape">
    <div class="d-flex justify-content-between">
      <div>
        <p class="text-uppercase mb-2 font-size-16">
          {{ distributor.distributor_name }}
        </p>
        <p class="text-uppercase mb-2 font-size-16">
          {{$t('print.address_x', {value: distributor.distributor_address})}}
        </p>
        <p class="text-uppercase mb-0 font-size-16">
          {{$t('print.tel_x', {value: distributor.distributor_phone})}}
        </p>
      </div>
      <div></div>
    </div>
    <h2 class="text-uppercase text-center pt-3">
      {{$t('debit_note')}}
    </h2>
    <div class="mb-3 print-content">
      <p class="text-left mt-3 mb-1" v-if="data.date">
        {{$t('print.from_date_to_date', {from: data.date[0]&&formatDate(data.date[0])||'---', to: data.date[1]&&formatDate(data.date[1])||'---'})}}
      </p>
      <p class="text-left" v-if="data.customer">
        {{$t('client')}}: {{ data.customer }}
      </p>
    </div>

    <table class="table table-bordered font-size-16 border-black">
      <tr>
        <th v-for="(item) in fields" :key="'header'+item.key">
            {{$t(item.header)}}
        </th>
      </tr>
      <tr v-for="(item, key) of data.details" :key="key">
        <td v-for="header in fields" :key="'item'+header.key" :style="item.style||''">
          {{ header.key === 'document_type_text' ? translateCol(item['document_type']) : item[header.key]}}
        </td>
      </tr>
      <tfoot class="footer-repeat no-border">
      <!-- add repeated tfoot for extra space -->
      <tr class="no-border">
        <td class="no-border">&nbsp;</td>
      </tr>
      </tfoot>
    </table>
    <div class="print-footer d-flex justify-content-around font-size-16 pt-3">
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">{{$t('customer_s_confirmation')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
      <div>
        <p>
          {{$t('print.day_month_year', {d: timePrint.day, m: timePrint.month, y: timePrint.year})}}
        </p>
        <p class="font-weight-medium text-center mb-0">{{$t('schedule_maker')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
    </div>
  </div>
</template>
